
// Generated with baseline-styles - Do not modify.
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.styles = {
    "column": "column-632f8bf7",
    "fit-height": "fit-height-632f8bf7",
    "fit-width": "fit-width-632f8bf7",
    "fit-both": "fit-both-632f8bf7",
    "center": "center-632f8bf7",
    "middle": "middle-632f8bf7",
    "spacing-none": "spacing-none-632f8bf7",
    "spacing-normal": "spacing-normal-632f8bf7",
    "spacing-narrow": "spacing-narrow-632f8bf7",
    "spacing-wide": "spacing-wide-632f8bf7",
    "fitHeight": "fit-height-632f8bf7",
    "fitWidth": "fit-width-632f8bf7",
    "fitBoth": "fit-both-632f8bf7",
    "spacingNone": "spacing-none-632f8bf7",
    "spacingNormal": "spacing-normal-632f8bf7",
    "spacingNarrow": "spacing-narrow-632f8bf7",
    "spacingWide": "spacing-wide-632f8bf7"
};
exports.styleSource = ".column-632f8bf7{display:flex;flex-direction:column;align-items:flex-start;width:fit-content}.fit-height-632f8bf7{height:100%}.fit-width-632f8bf7{width:100%;align-items:stretch}.fit-both-632f8bf7{width:100%;height:100%;align-items:stretch}.center-632f8bf7{width:100%;align-items:center}.middle-632f8bf7{justify-content:center;height:100%}.spacing-none-632f8bf7>*{margin:0}.spacing-normal-632f8bf7>*{margin-bottom:1em}.spacing-normal-632f8bf7>*:last-child{margin-bottom:0}.spacing-narrow-632f8bf7>*{margin-bottom:.5em}.spacing-narrow-632f8bf7>*:last-child{margin-bottom:0}.spacing-wide-632f8bf7>*{margin-bottom:2em}.spacing-wide-632f8bf7>*:last-child{margin-bottom:0}";
exports.default = exports.styles;
            
module.moduleType = "style";
